<card name="Пагинация">
  <pagination card content [itemsOnPage]="50" [page]="1" [itemsFull]="240"></pagination>
</card>
